import {
  Button,
  getPrimaryColor,
  INSURANCE_TYPE,
  Styles,
} from '@orcar/common-d2c';
import styled from 'styled-components';
import { app } from '@/constants/common';
import { InsuranceTable } from './InsuranceTable';
import { ContentWrapper } from '../../../components/reservationDetails/commonStyles';
import { OrderConfirmationProps } from '../orderConfirmation/OrderConfirmationPage';
import * as S from '../orderConfirmation/styles';

interface InsuranceProps extends OrderConfirmationProps {
  insuranceId: string;
  coverageLimit: string;
  deductible: string;
  fullCoverageInsurancePrice?: number;
  lossOfUseFee: string;
  addInsurance?: boolean;
  buttonDisabled?: boolean;
  buttonLoading?: boolean;
  companyName: string;
  canAddUnlimitedOption?: boolean;
  onClick: () => void;
}

const InsuranceInfo = ({
  isMobile,
  insuranceId,
  fullCoverageInsurancePrice,
  coverageLimit,
  deductible,
  lossOfUseFee,
  addInsurance,
  companyName,
  buttonDisabled,
  buttonLoading,
  canAddUnlimitedOption,
  onClick,
}: InsuranceProps) => {
  const isSuper = insuranceId === INSURANCE_TYPE.SUPER;
  const isHidden = isSuper || !canAddUnlimitedOption;

  return (
    <ContentWrapper hasPadding>
      <S.SectionTitle isMobile={isMobile}>자차보험 정보</S.SectionTitle>
      <InsuranceTable
        addInsurance={addInsurance}
        isMobile={isMobile}
        insurance={insuranceId}
        companyName={companyName}
        canAddUnlimitedOption={!!canAddUnlimitedOption}
        coverageLimit={coverageLimit}
        deductible={deductible}
        lossOfUseFee={lossOfUseFee}
      />
      {isHidden ? null : (
        <>
          <AdditionalDescription>
            미보장 항목이 걱정되나요? 안전하고 편안한 제주 여행을 책임지는{' '}
            무제한특약으로 업그레이드 해보세요!
          </AdditionalDescription>
          <Button
            className={addInsurance ? 'cancelUnlimited' : 'takeUnlimited'}
            height='41px'
            bgColor={addInsurance ? Styles.COLOR.WHITE : getPrimaryColor(app)}
            color={addInsurance ? Styles.COLOR.GREY_02 : Styles.COLOR.WHITE}
            borderColor={addInsurance ? Styles.COLOR.GREY_02 : undefined}
            borderRadius={Styles.BORDER_RADIUS.LEVEL_01}
            font={Styles.FONT.B1}
            fontWeight={600}
            disabled={buttonDisabled}
            isLoading={buttonLoading}
            onClick={onClick}
          >
            {addInsurance
              ? `무제한특약 가입 취소하기`
              : `+${fullCoverageInsurancePrice?.toLocaleString()}원으로 무제한특약 가입하기`}
          </Button>
        </>
      )}
    </ContentWrapper>
  );
};

export { InsuranceInfo };

const AdditionalDescription = styled.p`
  margin-bottom: 16px;
  ${({ theme }) => theme.FONT.B2};
  color: ${({ theme }) => theme.COLOR.GREY_02};
  word-break: keep-all;
`;
